<div [ngSwitch]="renderer">
	<app-card-style-object-renderer *ngSwitchCase="'object'"
		[property]="property" [schema]="resolvedSchema" [schemaKey]="schemaKey"
		[data]="data" [formConfig]="parseReadOnly(formConfig)"
		[required]="required" (valid)="setValid($event)"></app-card-style-object-renderer>
	<app-card-style-string-renderer *ngSwitchCase="'string'"
		[property]="property" [schema]="resolvedSchema" [schemaKey]="schemaKey"
		[data]="data" [formConfig]="parseReadOnly(formConfig)"
		[required]="required" (valid)="setValid($event)"></app-card-style-string-renderer>
	<app-card-style-array-renderer *ngSwitchCase="'array'"
		[property]="property" [schema]="resolvedSchema" [schemaKey]="schemaKey"
		[data]="data" [formConfig]="parseReadOnly(formConfig)"
		[required]="required" (valid)="setValid($event)"></app-card-style-array-renderer>
	<div *ngSwitchDefault>{{schema?.type}}</div>
	<app-card-style-enum-renderer *ngSwitchCase="'enum'"
		[property]="property" [schema]="resolvedSchema" [schemaKey]="schemaKey"
		[data]="data" [formConfig]="parseReadOnly(formConfig)"
		[required]="required" (valid)="setValid($event)"></app-card-style-enum-renderer>
	<app-card-style-date-renderer *ngSwitchCase="'date'"
		[property]="property" [schema]="resolvedSchema" [schemaKey]="schemaKey"
		[data]="data" [formConfig]="parseReadOnly(formConfig)"
		[required]="required" (valid)="setValid($event)"></app-card-style-date-renderer>
	<div *ngSwitchDefault>{{renderer}}</div>

</div>
